import script from "./SendOtpForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendOtpForm.vue?vue&type=script&lang=ts&setup=true"

import "./SendOtpForm.vue?vue&type=style&index=0&id=06546d4c&lang=css"

const __exports__ = script;

export default __exports__